<template>
  <div class="row">
    <div class="col-sm-6 mx-auto">
      <div class="alert alert-info" role="alert">
        Recuerde utilizar archivos con extensión XLS
      </div>

      <form @submit.prevent="guardar">
        <div class="form-group row mb-1">
          <div class="col-sm-12">
            <label for="inputArchivo" class="col-form-label mb-0 font-weight-bold">Archivo:</label>
            <div class="input-group mb-0">
              <div class="custom-file">
                <input type="file" name="archivo" class="custom-file-input custom-file-input-sm" id="inputGroupFile02" @change="setFile" required>
                <label class="custom-file-label" for="inputGroupFile02" aria-describedby="inputGroupFileAddon02">
                  {{ nombre === null ? 'Buscar...' : nombre }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row mb-2">
          <div class="col-sm-6">
            <label for="inputInicio" class="col-form-label mb-0 font-weight-bold">Inicio:</label>
            <input type="number" class="form-control form-control-sm" name="inicio" required>
          </div>
          <div class="col-sm-6">
            <label for="inputFin" class="col-form-label mb-0 font-weight-bold">Fin:</label>
            <input type="number" class="form-control form-control-sm" name="fin" required>
          </div>
        </div>
        <div class="form-group row mb-1">
          <div class="col-sm-12 text-right">
            <button class="btn btn-sm btn-primary" :disabled="btnGuardar">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
                v-if="btnGuardar"
              ></span>
              <span class="sr-only" v-if="btnGuardar">
                Guardando...
              </span>
              <span v-if="!btnGuardar">
                Guardar
              </span>
            </button>
          </div>
        </div>
        <div class="form-group row mb-0" v-if="guias.length > 0">
          <div class="col-sm-12">
            <p>Guías creadas:</p>
            <p v-for="i in guias" :key="i">{{ i }}</p>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import Notificacion from '../mixins/Notificacion.js';

  export default {
    name: 'GuiaCrearXls',
    mixins: [Notificacion],
    data: () => {
      return {
        btnGuardar: false,
        nombre: null,
        guias: []
      }
    },
    methods: {
      guardar(e) {
        if (confirm('¿Está seguro?')) {
          this.btnGuardar = true;

          let datos = new FormData(e.target);

          axios
          .post(`${this.UrlBase}/hija/crear_guia`, datos)
          .then(res => {
            this.btnGuardar = false;

            if (res.data.exito) {
              this.nombre = null;
              this.guias = res.data.guias;
              this.showSuccessMsg({message: res.data.mensaje});
              e.target.reset();
            } else {
              this.showErrorMsg({message: res.data.mensaje});
            }
          }).catch(e => {
            this.btnGuardar = false;
            alert('Xls '+e);
          })
        }
      },
      setFile(e) {
        this.nombre = e.target.files[0].name;
      }
    }
  };
</script>